import React from 'react'

const Child = (x) => {
    console.log(x)
    //x={name:"ilander",fun1:receive1}
    let {name,fun} = x
    let obj = {name:"iLander",age:"10Years"}

    const send1=()=>{
        fun(obj)
    }
  return (
    <>
      <h3>Welcome to Child Component {name}</h3>
      <button className='btn btn-danger mt-4' onClick={send1}>Send To Parent</button>
    </>
  )
}

export default Child
